import UIStore from './UIStore';

const uiStore = new UIStore();

export default {
  uiStore,
};
